import { HEX } from "../../../src/actions/hex-patterns";
import { Targeting } from "../../../src/actions/targeting";
import { SEC } from "../../../src/time-utils";
const shadow_lure = {
  slug: "shadow_lure",
  name: "Shadow Lure",
  description: "Draws an enemy toward you with shadow tendrils",
  abilityIcon: "shadow_lure",
  costs: [
    { stat: "energy", value: 15 }
  ],
  targeting: Targeting.MissileMid,
  cooldown: SEC(6),
  projectileSpeed: 8,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {}
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "ranged", "black", "cc"]
};
export {
  shadow_lure
};
//# sourceMappingURL=data:application/json;base64,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
